import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CreateSpotlight from './submodules/create';
import ListSpotlight from './submodules/list';
import UpdateSpotlight from './submodules/edit';

const SpotlightDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.social}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].listContent]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListSpotlight}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.social}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].createContent]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateSpotlight}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.social}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].updateContent]}
				path={`${path}/edit`}
				configPageName={PAGE_NAMES.dashboard}
				component={UpdateSpotlight}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default SpotlightDashboard;
